import { z } from "zod"

/**
 * `payments`: money received against an invoice (T412, PRD R2). Amounts are integer minor
 * units. No payment receipts are issued (owner decision pending); a payment only moves the
 * invoice status. Request schemas strict, stored/response lenient.
 */

export const PAYMENT_METHODS = ["bank_transfer", "cash", "card", "other"] as const
export const paymentMethodSchema = z.enum(PAYMENT_METHODS)
export type PaymentMethod = z.infer<typeof paymentMethodSchema>

/** Largest single payment: A$1,000,000,000.00 in cents (same bound as an expense). */
export const PAYMENT_MAX_AMOUNT_MINOR = 100_000_000_000

export const paymentSchema = z.object({
  id: z.uuid(),
  organisation_id: z.uuid(),
  invoice_id: z.uuid(),
  amount_minor: z.number().int(),
  received_on: z.string().date(),
  method: paymentMethodSchema,
  reference: z.string().nullable().default(null),
  deleted_at: z.string().datetime({ offset: true }).nullable().default(null),
  created_at: z.string().datetime({ offset: true }),
  updated_at: z.string().datetime({ offset: true }),
})

export type Payment = z.infer<typeof paymentSchema>

export const recordPaymentRequestSchema = z.strictObject({
  id: z.uuid().optional(),
  amount_minor: z.number().int().min(1).max(PAYMENT_MAX_AMOUNT_MINOR),
  received_on: z.string().date(),
  method: paymentMethodSchema,
  reference: z.string().trim().max(100).nullable().default(null),
})

export type RecordPaymentRequest = z.input<typeof recordPaymentRequestSchema>
export type ParsedRecordPaymentRequest = z.infer<typeof recordPaymentRequestSchema>
